import bceceEngineeringCutoffs from '../data/bcece-engineering/BCECE_Engineering_Cutoffs_2026.json';
import dcecePmmCutoffs from '../data/dcece-paramedical/DCECE_PMM_MatricLevel_Cutoffs_2026.json';
import dcecePmCutoffs from '../data/dcece-paramedical/DCECE_PM_InterLevel_Cutoffs_2026.json';
import dcecePolytechnicCutoffs from '../data/dcece-polytechnic/DCECE_Polytechnic_Cutoffs_2026.json';
import ugmacAyushCutoffs from '../data/ugmac-ayush/UGMAC_Ayush_Cutoffs_2025.json';
import { getExamSeatMatrixModule } from './examSeatMatrixModules.js';
import { getCollegePriority } from './collegePriority.js';
import {
  getBranchPriority,
  getCutoffScore,
  getPredictionStatus,
  getPredictorWeightedScore,
} from './predictor.js';
import {
  getUgmacCollegePreferenceRank,
  getUgmacCoursePreferenceRank,
} from './ugmacData.js';
import { matchesSelection } from './filterSelection.js';

const categoryOrder = ['UR', 'EWS', 'BC', 'EBC', 'SC', 'ST', 'RCG', 'DQ', 'E-UR'];

const normalizeText = (value = '') => String(value).replace(/\s+/g, ' ').trim();
const compactText = (value = '') => normalizeText(value).toLowerCase().replace(/[^a-z0-9]+/g, '');

const GOVERNMENT_ENGINEERING_COLLEGES = new Set([
  'bcebhagalpur',
  'bcebakhtiyarpur',
  'mitmuzaffarpur',
  'gcegaya',
  'dcedarbhanga',
  'mcemotihari',
  'lnjpittechnologychapra',
  'sitsitamarhi',
  'scesasaram',
  'kcekatihar',
  'purneacollegeofengg',
  'rrsdcebegusarai',
  'bpmcemadhepura',
  'shriphanishwarnathrenuenggcollegeararia',
  'govtenggcollegebhojpur',
  'govtenggcollegearwal',
  'govtenggcollegeaurangabad',
  'govtenggcollegebanka',
  'govtenggcollegebuxar',
  'govtenggcollegegopalganj',
  'govtenggcollegejamui',
  'govtenggcollegejehanabad',
  'govtenggcollegekaimur',
  'govtenggcollegekhagaria',
  'govtenggcollegemadhubani',
  'govtenggcollegenawada',
  'govtenggcollegemunger',
  'govtenggcollegesheikhpura',
  'govtenggcollegesheohar',
  'govtenggcollegesiwan',
  'govtenggcollegeofsamastipur',
  'govtenggcollegevaishali',
  'govtenggcollegewchamparan',
  'govtenggcollegeoflakhisarai',
  'govtenggcollegekishanganj',
  'nalandacollegeofenggchandi',
  'supaulenggcollegesupaul',
  'saharsacollegeofengg',
  'collegeofagriculturalengineeringarabhojpur',
]);

const GOVERNMENT_POLYTECHNIC_COLLEGES = new Set([
  'bknsgpgopalganj',
  'bkpinstsitamarhi',
  'gpararia',
  'gparwal',
  'gpaurangabad',
  'gpbanka',
  'gpbarh',
  'gpbhojpur',
  'gpbuxar',
  'gpjamui',
  'gpjehanabad',
  'gpkaimur',
  'gpkhagaria',
  'gpkishanganj',
  'gpmadhepura',
  'gpmunger',
  'gpnawada',
  'gpsheikhpura',
  'gpsitamarhi',
  'gpsiwan',
  'gpsupaul',
  'gptekarigaya',
  'gpwestchamparan',
  'gpasthawannalanda',
  'gpbaraunibegusarai',
  'gpbhagalpur',
  'gpchapramarhowrahsaran',
  'gpdarbhanga',
  'gpdehrionsone',
  'gpgaya',
  'gpgopalganj',
  'gpkatihar',
  'gplakhisarai',
  'gpmadhubani',
  'gpmotihari',
  'gpmuzaffarpur',
  'gppatna7',
  'gppurnea',
  'gpsaharsa',
  'gpsheohar',
  'gptextiletechnathnagarbhagalpur',
  'gpvaishali',
  'gwpmuzaffarpur',
  'gwppatna14',
  'knsgpsamastipur',
]);

const PARAMEDICAL_PRIVATE_KEYWORDS = [
  'aayushman', 'akash', 'ambbedkar', 'ambedkar', 'anju', 'bhavya', 'budha', 'patliputra',
  'prameela', 'patna institute', 'patel', 'd.p. singh', 'dp singh', 'daksh', 'darbhanga nursing',
  'dhanarua', 'nesar', 'g.m.', 'gm', 'gautam', 'himalaya', 'himalya', 'hirawati', 'khawaja',
  'kingway', 'mgm', 'mundeshwari', 'manorama', 'bhagwati', 'maharishi', 'sushila', 'kanti',
  'mona', 'mother teresa', 'naina', 'nalanda nursing', 'national', 'om sai', 'paras',
  'parmarth', 'prameela', 'rb memorial', 'r.b. memorial', 'rp singh', 'r.p. singh', 'rup bala', 'rupbala',
  'sanjeevani', 'saroj', 'sarvoday', 'sadhu sharan', 'shershah', 'shri bhagwat', 'shyam lal',
  'subhwanti', 'swami', 'vidya', 'yamuna', 'raj kumari', 'srt memorial', 's.r.t. memorial',
  'yogendra', 'doon', 'shivam', 'krishna', 'saran nursing', 'aihe', 'deen dayal', 'b.s. institute',
  'bs institute', 'raj aryan', 'modern', 'nutan', 'benipur nursing', 'shyam school', 'nazma',
  'mahavir', 'sns institute', 's.n.s. institute', 'rrp school', 'r.r.p. school', 'rrp', 'vaidhnath',
  'nazirul', 'chandargupt', 'k.r.', 'kr', 'shakuntala', 'gyanjyoti', 'dps', 'd.p.s.', 'mitra',
  'dhano devi', 'sheikhpura institute', 'guidance', 'balajee', 'savitri', 'r.g. college',
  'rg college', 'trivaini', 'triveni', 'rs institute', 'r.s. institute', 'kk institute',
  'k.k. institute', 'nawada college', 'rajgir anm', 'mirganj', 'rb chandra', 'r.b. chandra',
  'ramakanti', 'vivekanand', 'magadh', 'aryabhat', 'pinak', 'bala jee', 'anushka', 'raj anm',
  'sa institute', 's.a. institute', 'satyandaram', 'jagdamba', 'madhubani institute', 'maitre',
  'subhadra', 'bhagalpur institute', 'kalami', 'katihar anm', 'gagdish', 'sk global', 's.k. global',
  'nwabang', 'navrang', 'ledar', 'leedar', 'skm nursing', 's.k.m. nursing', 'shree raj',
  'tripolia', 'gems', 'kameswar', 'kameswhar', 'raghunandan', 'simanchal', 'kailash', 'yashoda',
  'priyadarshani', 'ram sharan', 'ramsharan', 'raj kishor', 'rajkishor', 'trisha', 'humanity',
  'lav kush', 'lavkush', 'chanakya', 'kamleswari', 'hemwanti', 'skm college', 's.k.m. college',
  'narayan', 'vimla', 'jiya', 'kedarnath', 'dt institute', 'd.t. institute', 'global',
  'vaidehi', 'manav', 'ashoka', 'gulab', 'moty', 'moti babu', 'motibabu', 'children',
  'aaryamn', 'aaryaman', 'narmada', 'gurudev', 'life line', 'lifeline', 'ma savitri', 'royal',
  'universal', 'hira singh', 'ramdhari', 'gangotri', 'lt nursing', 'l.t. nursing', 'radiant',
  'vishundev', 'dev vally', 'dev valley', 'manorma', 'ss college', 's.s. college', 'm. kumar',
  'm kumar', 'sharda', 'rbsrdr', 'r.b.s.r.d.r.', 'stephene', 'gyatri', 'gayatri', 'rampratap',
  'sudarshan', 'applo', 'apolo', 'apollo', 'binda', 'pratik', 'tara chandi', 'tarachandi',
  'ahs building', 'panasiya', 'pnasiya', 'arjun', 'jandaha', 'mamta', 'lrd budha', 'lard budha',
  'lord budha', 'lord buddha', 'anamika', 'netaji', 'exalt', 'sityog', 'kinesis', 'rungta',
  'm.r. institute', 'mr institute', 'k.r. nursing', 'kr nursing', 'aryabhatt', 'j.p.i.t.', 'jpit',
  'm.r. college', 'mr college', 'applo nursing', 'appolo nursing'
];

const PARAMEDICAL_PRIVATE_PATTERNS = PARAMEDICAL_PRIVATE_KEYWORDS.map(keyword => {
  const escaped = keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  return new RegExp(`\\b${escaped}\\b`, 'i');
});

const inferInstituteTypeFromName = (moduleKey, institution = '') => {
  const label = normalizeText(institution).toLowerCase();
  if (!label) {
    return '';
  }

  const hasAny = (patterns) => patterns.some((pattern) => pattern.test(label));

  if (moduleKey === 'paramedical') {
    // Explicitly check for government institutions or address snippets to prevent false positives
    if (
      /\b(civil surgeon|pmi|pmch|dmch|nmch|skmch|anmmch|jlnmch|jlnmc|bmims|pdc|phi|gpi|govt|government)\b/i.test(label) ||
      /\bg\.?m\.?c\.?\b/i.test(label)
    ) {
      if (
        label.startsWith('pmi') ||
        label.includes('under civil surgeon') ||
        label.includes('pmch') ||
        label.includes('nmch') ||
        label.includes('dmch') ||
        label.includes('gmc') ||
        /\bg\.?m\.?c\.?\b/i.test(label)
      ) {
        return 'Government';
      }
    }

    // GNM/ANM Government Schools & Training Schools
    const isGovtNurs = /\b(anm school|anm training|gnm training|gnm school|g\.n\.m\.\s+school|g\.n\.m\.\s+training|g\.n\.m\.\s+institute)\b/i.test(label);
    if (isGovtNurs) {
      const hasPrivKeyword = PARAMEDICAL_PRIVATE_PATTERNS.some((pattern) => pattern.test(label));
      return hasPrivKeyword ? 'Private' : 'Government';
    }

    // General private markers
    if (/\b(nursing|paramedical|academy|institute|higher studies|college of|education|foundation|association|trust|private)\b/i.test(label)) {
      return 'Private';
    }

    const isPriv = PARAMEDICAL_PRIVATE_PATTERNS.some((pattern) => pattern.test(label));
    return isPriv ? 'Private' : 'Government';
  }

  if (moduleKey === 'polytechnic') {
    const key = compactText(institution);
    return GOVERNMENT_POLYTECHNIC_COLLEGES.has(key) ? 'Government' : 'Private';
  }

  if (moduleKey === 'bceceEngineering') {
    const key = compactText(institution);
    return GOVERNMENT_ENGINEERING_COLLEGES.has(key) ? 'Government' : 'Private';
  }

  return '';
};

const slugify = (value = '') =>
  normalizeText(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const buildInstituteTypeLookup = (moduleKey) => {
  const seatMatrixModule = getExamSeatMatrixModule(moduleKey);
  const lookup = new Map();

  seatMatrixModule?.data?.forEach((row) => {
    const key = compactText(row.institution);
    if (key && row.instituteType && !lookup.has(key)) {
      lookup.set(key, normalizeText(row.instituteType));
    }
  });

  return lookup;
};

const normalizeCutoffRows = (
  rows = [],
  { moduleKey = '', hasSeatType = false, instituteTypeLookup = new Map() } = {},
) =>
  rows.map((row) => ({
    institute: normalizeText(row.institute),
    branch: normalizeText(row.branch),
    instituteType:
      instituteTypeLookup.get(compactText(row.institute)) ||
      inferInstituteTypeFromName(moduleKey, row.institute) ||
      '',
    seatType: hasSeatType ? normalizeText(row.seatType || 'General') : 'General',
    category: normalizeText(row.category),
    urOpeningRank: row.urOpeningRank ?? null,
    urClosingRank: row.urClosingRank ?? null,
    categoryOpeningRank: row.categoryOpeningRank ?? null,
    categoryClosingRank: row.categoryClosingRank ?? null,
  }));

const bceceRows = normalizeCutoffRows(bceceEngineeringCutoffs, {
  moduleKey: 'bceceEngineering',
  hasSeatType: true,
  instituteTypeLookup: buildInstituteTypeLookup('bceceEngineering'),
});
const pmRows = normalizeCutoffRows(dcecePmCutoffs, {
  moduleKey: 'paramedical',
  instituteTypeLookup: buildInstituteTypeLookup('paramedical'),
});
const pmmRows = normalizeCutoffRows(dcecePmmCutoffs, {
  moduleKey: 'paramedical',
  instituteTypeLookup: buildInstituteTypeLookup('paramedical'),
});
const polytechnicRows = normalizeCutoffRows(dcecePolytechnicCutoffs, {
  moduleKey: 'polytechnic',
  instituteTypeLookup: buildInstituteTypeLookup('polytechnic'),
});
const ugmacAyushRows = normalizeCutoffRows(ugmacAyushCutoffs, {
  moduleKey: 'ugmacAyush',
  hasSeatType: true,
  instituteTypeLookup: buildInstituteTypeLookup('ugmacAyush'),
});

export const examCutoffModules = {
  bceceEngineering: {
    key: 'bceceEngineering',
    title: 'BCECE Engineering',
    shortLabel: 'BCECE Engineering',
    predictorPath: '/bcece-engineering-predictor',
    dataPath: '/bcece-engineering-cutoff-seat-matrix',
    description:
      'Remaining-seat engineering cutoff data for BCECE Engineering counselling in Bihar.',
    data: bceceRows,
    hasSeatType: true,
    hasVariant: false,
  },
  paramedical: {
    key: 'paramedical',
    title: 'Bihar Paramedical (DCECE PM / PMM)',
    shortLabel: 'DCECE PM / PMM',
    predictorPath: '/paramedical-predictor',
    dataPath: '/paramedical-cutoff-seat-matrix',
    description:
      'Inter-level and matric-level paramedical cutoff data for Bihar DCECE PM and PMM counselling.',
    hasSeatType: false,
    hasVariant: true,
    variants: [
      {
        key: 'pm',
        label: 'Inter Level (PM)',
        data: pmRows,
      },
      {
        key: 'pmm',
        label: 'Matric Level (PMM)',
        data: pmmRows,
      },
    ],
  },
  polytechnic: {
    key: 'polytechnic',
    title: 'Bihar Polytechnic (DCECE PE)',
    shortLabel: 'DCECE PE',
    predictorPath: '/polytechnic-predictor',
    dataPath: '/polytechnic-cutoff-seat-matrix',
    description:
      'Polytechnic cutoff data for Bihar DCECE PE admissions across available diploma branches.',
    data: polytechnicRows,
    hasSeatType: false,
    hasVariant: false,
  },
  ugmacAyush: {
    key: 'ugmacAyush',
    title: 'Bihar Medical (UGMAC Ayush)',
    shortLabel: 'UGMAC Ayush',
    predictorPath: '/ugmac-ayush-predictor',
    dataPath: '/ugmac-ayush-cutoff-seat-matrix',
    description:
      'AYUSH cutoff data for Bihar UGMAC counselling across B.A.M.S., B.H.M.S., and B.U.M.S. courses.',
    data: ugmacAyushRows,
    hasSeatType: true,
    hasVariant: false,
    requiresNeetRank: true,
    neetRankLabel: 'NEET Rank',
    neetRankPlaceholder: 'Enter NEET rank',
    generalRankLabel: 'UR Rank',
    generalRankPlaceholder: 'Enter UR rank',
    categoryRankLabel: 'Category Rank',
    categoryRankPlaceholder: 'Enter category rank',
    summaryGeneralRankLabel: 'UR Rank',
    summaryCategoryRankLabel: 'Category Rank',
  },
};

export const getExamCutoffModule = (moduleKey) => examCutoffModules[moduleKey] ?? null;

export const getExamVariantRows = (moduleKey, variantKey = 'default') => {
  const module = getExamCutoffModule(moduleKey);
  if (!module) return [];
  if (!module.hasVariant) {
    return module.data;
  }
  return module.variants.find((variant) => variant.key === variantKey)?.data ?? module.variants[0]?.data ?? [];
};

export const getExamVariantOptions = (moduleKey) => {
  const module = getExamCutoffModule(moduleKey);
  if (!module?.hasVariant) return [];
  return module.variants.map((variant) => ({ key: variant.key, label: variant.label }));
};

export const getExamInstituteOptions = (moduleKey, variantKey = 'default') =>
  [...new Set(getExamVariantRows(moduleKey, variantKey).map((row) => row.institute))].sort((a, b) =>
    a.localeCompare(b),
  );

export const getExamInstituteTypeOptions = (moduleKey, variantKey = 'default') => {
  if (moduleKey === 'bceceEngineering') {
    return ['Government', 'Private'];
  }
  return [...new Set(getExamVariantRows(moduleKey, variantKey).map((row) => row.instituteType).filter(Boolean))].sort((a, b) =>
    a.localeCompare(b),
  );
};

export const getExamBranchOptions = (moduleKey, variantKey = 'default') =>
  [...new Set(getExamVariantRows(moduleKey, variantKey).map((row) => row.branch))].sort((a, b) =>
    a.localeCompare(b),
  );

export const getExamSeatTypeOptions = (moduleKey, variantKey = 'default') => {
  const rows = getExamVariantRows(moduleKey, variantKey);
  const seatTypes = [...new Set(rows.map((row) => row.seatType).filter(Boolean))];
  return seatTypes.length > 1 ? seatTypes : ['General'];
};

export const getExamCategoryOptions = (
  moduleKey,
  variantKey = 'default',
  { institute = 'All', branch = 'All', seatType = 'All', instituteType = 'All' } = {},
) => {
  const rows = getExamVariantRows(moduleKey, variantKey).filter(
    (row) =>
      (instituteType === 'All' || row.instituteType === instituteType) &&
      matchesSelection(row.institute, institute) &&
      matchesSelection(row.branch, branch) &&
      (seatType === 'All' || row.seatType === seatType),
  );

  const categories = [...new Set(rows.map((row) => row.category))];
  return [
    'All',
    ...categoryOrder.filter((category) => categories.includes(category)),
    ...categories
      .filter((category) => !categoryOrder.includes(category))
      .sort((first, second) => first.localeCompare(second)),
  ];
};

export const filterExamCutoffRows = (
  moduleKey,
  {
    variantKey = 'default',
    instituteType = 'All',
    institute = 'All',
    branch = 'All',
    seatType = 'All',
    category = 'All',
  } = {},
) =>
  getExamVariantRows(moduleKey, variantKey)
    .filter((row) => instituteType === 'All' || row.instituteType === instituteType)
    .filter((row) => matchesSelection(row.institute, institute))
    .filter((row) => matchesSelection(row.branch, branch))
    .filter((row) => seatType === 'All' || row.seatType === seatType)
    .filter((row) => category === 'All' || row.category === category)
    .map((row) => ({
      ...row,
      openingRank: row.category === 'UR' || row.category === 'E-UR'
        ? row.urOpeningRank ?? null
        : row.categoryOpeningRank ?? row.urOpeningRank ?? null,
      closingRank: row.category === 'UR' || row.category === 'E-UR'
        ? row.urClosingRank ?? null
        : row.categoryClosingRank ?? row.urClosingRank ?? null,
    }))
    .sort(
      (first, second) =>
        first.institute.localeCompare(second.institute) ||
        first.branch.localeCompare(second.branch) ||
        first.seatType.localeCompare(second.seatType) ||
        first.category.localeCompare(second.category),
    );

const getClosingRank = (row) =>
  row.category === 'UR' || row.category === 'E-UR'
    ? row.urClosingRank ?? null
    : row.categoryClosingRank ?? row.urClosingRank ?? null;

const getOpeningRank = (row) =>
  row.category === 'UR' || row.category === 'E-UR'
    ? row.urOpeningRank ?? null
    : row.categoryOpeningRank ?? row.urOpeningRank ?? null;
const statusOrder = {
  'LOW CHANCE': 0,
  BORDERLINE: 1,
  SAFE: 2,
  'NO CHANCE': 3,
};

const getModulePriorities = (moduleKey, row) => {
  if (moduleKey === 'bceceEngineering') {
    return {
      collegePriority: getCollegePriority(row.institute),
      branchPriority: getBranchPriority(row.branch, row.branch),
    };
  }

  if (moduleKey === 'ugmacAyush') {
    return {
      collegePriority: getUgmacCollegePreferenceRank(row.institute),
      branchPriority: getUgmacCoursePreferenceRank(row.branch),
    };
  }

  return {
    collegePriority: 9999,
    branchPriority: 9999,
  };
};

export const predictExamCutoffRows = (
  moduleKey,
  {
    variantKey = 'default',
    generalRank,
    categoryRank,
    category = 'UR',
    instituteType = 'All',
    institute = 'All',
    branch = 'All',
    gender = 'Male',
    seatType = 'All',
    rcgRank,
    femaleGeneralRank,
    femaleCategoryRank,
  } = {},
) => {
  const numericGeneralRank = Number(generalRank);
  const numericCategoryRank = Number(categoryRank);

  if (!numericGeneralRank || numericGeneralRank <= 0) {
    return [];
  }

  const availableSeatTypes = getExamSeatTypeOptions(moduleKey, variantKey);
  const resolvedSeatType =
    seatType !== 'All'
      ? seatType
      : availableSeatTypes.length > 1
        ? gender === 'Female'
          ? 'All' // Females are eligible for both open/general and female-only seats
          : 'General'
        : 'General';

  const rows = filterExamCutoffRows(moduleKey, {
    variantKey,
    instituteType,
    institute,
    branch,
    seatType: resolvedSeatType,
    category: 'All',
  }).filter((row) => {
    // Exclude female-only courses and institutes for male candidates
    if (gender === 'Male') {
      const isFemaleOnlyBranch =
        moduleKey === 'paramedical' &&
        (row.branch.toUpperCase().includes('A.N.M.') ||
          row.branch.toUpperCase().includes('G.N.M.') ||
          row.branch.toUpperCase().includes('ANM') ||
          row.branch.toUpperCase().includes('GNM'));
      const isFemaleOnlyInstitute =
        moduleKey === 'polytechnic' &&
        (row.institute.toUpperCase().includes('WOMEN') ||
          row.institute.toUpperCase().includes('GW.P.') ||
          row.institute.toUpperCase().includes('G.W.P'));

      if (isFemaleOnlyBranch || isFemaleOnlyInstitute) {
        return false;
      }
    }

    const cat = row.category;
    const isRcgCat = cat === 'RCG' || cat === 'E-RCG';
    if (gender === 'Female') {
      if (category === 'All') {
        return true;
      }
      if (moduleKey === 'ugmacAyush' || moduleKey === 'bceceEngineering') {
        const canCompeteForRcg = category !== 'UR' && category !== 'EWS';
        if (isRcgCat) {
          return canCompeteForRcg;
        }
        if (category === 'UR') {
          return cat === 'UR' || cat === 'E-UR';
        }
      } else {
        if (category === 'UR') {
          return cat === 'UR' || cat === 'E-UR' || cat === 'RCG' || cat === 'E-RCG';
        }
      }
      return (
        cat === 'UR' ||
        cat === 'E-UR' ||
        cat === 'RCG' ||
        cat === 'E-RCG' ||
        cat === category ||
        cat === `E-${category}`
      );
    } else {
      if (category === 'All') {
        return true;
      }
      if (category === 'UR') {
        return cat === 'UR' || cat === 'E-UR';
      }
      return cat === 'UR' || cat === 'E-UR' || cat === category;
    }
  });

  return rows
    .map((row) => {
      const closingRank = getClosingRank(row);
      const openingRank = getOpeningRank(row);
      
      let rankUsed = Number.POSITIVE_INFINITY;
      const cat = row.category;

      if (gender === 'Female') {
        const isFemaleSeat = row.seatType === 'Female';
        const isRCG = cat === 'RCG' || cat === 'E-RCG';
        const isParamedicalFemaleBranch =
          moduleKey === 'paramedical' &&
          (row.branch.toUpperCase().includes('A.N.M.') ||
            row.branch.toUpperCase().includes('G.N.M.') ||
            row.branch.toUpperCase().includes('ANM') ||
            row.branch.toUpperCase().includes('GNM'));
        const isPolytechnicFemaleInstitute =
          moduleKey === 'polytechnic' &&
          (row.institute.toUpperCase().includes('WOMEN') ||
            row.institute.toUpperCase().includes('GW.P.') ||
            row.institute.toUpperCase().includes('G.W.P'));
        const isFemaleSpecific =
          isFemaleSeat || isRCG || isParamedicalFemaleBranch || isPolytechnicFemaleInstitute;

        if (isFemaleSpecific) {
          if (cat === 'UR' || cat === 'E-UR') {
            rankUsed = Number(femaleGeneralRank) || numericGeneralRank || Number.POSITIVE_INFINITY;
          } else if (cat === 'RCG' || cat === 'E-RCG') {
            rankUsed = Number(rcgRank) || Number(femaleGeneralRank) || numericGeneralRank || Number.POSITIVE_INFINITY;
          } else if (category === 'All' || cat === category || cat === `E-${category}`) {
            rankUsed = Number(femaleCategoryRank) || numericCategoryRank || Number.POSITIVE_INFINITY;
          }
        } else {
          if (cat === 'UR' || cat === 'E-UR') {
            rankUsed = numericGeneralRank;
          } else if (cat === 'RCG' || cat === 'E-RCG') {
            rankUsed = Number(rcgRank) || numericGeneralRank;
          } else if (category === 'All' || cat === category) {
            rankUsed = numericCategoryRank || Number.POSITIVE_INFINITY;
          }
        }
      } else {
        if (cat === 'UR' || cat === 'E-UR') {
          rankUsed = numericGeneralRank;
        } else if (category === 'All' || cat === category) {
          rankUsed = numericCategoryRank || Number.POSITIVE_INFINITY;
        }
      }

      const { collegePriority, branchPriority } = getModulePriorities(moduleKey, row);
      const status = getPredictionStatus({ rankUsed, closingRank });
      const gap = closingRank ? closingRank - rankUsed : Number.NEGATIVE_INFINITY;
      const cutoffScore = getCutoffScore({ rankUsed, closingRank });
      const weightedMeta = getPredictorWeightedScore({
        cutoffScore,
        collegePriority,
        branchPriority,
      });

      return {
        ...row,
        slug: slugify(row.institute),
        openingRank,
        closingRank,
        rankUsed,
        status,
        gap,
        collegePriority,
        branchPriority,
        cutoffScore,
        ...weightedMeta,
        rankType: row.category === 'UR' || row.category === 'E-UR' ? 'General Rank' : 'Category Rank',
        quotaCode: row.seatType === 'Female' ? `F_${row.category}` : row.category,
      };
    })
    .filter((row) => Number.isFinite(row.closingRank))
    .sort(
      (first, second) =>
        (statusOrder[first.status] ?? 99) - (statusOrder[second.status] ?? 99) ||
        (first.closingRank ?? Number.MAX_SAFE_INTEGER) - (second.closingRank ?? Number.MAX_SAFE_INTEGER) ||
        first.collegePriority - second.collegePriority ||
        first.branchPriority - second.branchPriority ||
        second.gap - first.gap ||
        second.weightedScore - first.weightedScore ||
        second.cutoffScore - first.cutoffScore ||
        first.institute.localeCompare(second.institute) ||
        first.branch.localeCompare(second.branch)
    );
};
